export default {
  root: {
    backgroundColor: 'white',
    'border-radius': '4px',
  },
};
